import { isTypeFeaturedProjectsSection } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulFeaturedProjectsSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeFeaturedProjectsSection(entry)) {
    return null;
  }

  return <div>ContentfulFeaturedProjectsSection</div>;
};

export default ContentfulFeaturedProjectsSection;
